import { render, staticRenderFns } from "./AppResetMailStep.vue?vue&type=template&id=0866ad32&"
import script from "./AppResetMailStep.vue?vue&type=script&lang=js&"
export * from "./AppResetMailStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports